// Truncate a string with ellipses if greater than specified length
export const truncate = (str, length = 100, ending = "...") => {
  // Check if provided string's length is greater than desired length
  return str.length > length ? str.substring(0, length - ending.length) + ending : str;
};